var path = 'components/auth/views/setplex-login.html';
var html = "<style>aside{opacity:0}</style> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;